import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckCircleIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    medal: '🥇',
    title: 'BONO 1 — Reto de los 30 Días',
    tagline: 'Empezá a vender en 30 días, no en 30 meses.',
    description: 'Tu mapa de ruta diario completo:',
    bullets: ['Qué comprar primero y dónde', 'Qué forma hacer primero (la más fácil y vendible)', 'Cómo secar y aromatizar en los primeros días', 'Cómo sacar tu primera foto de producto', 'Cómo conseguir tu primer cliente real'],
    footer: 'Sin vueltas. Sin excusas. Con un plan claro cada día.',
    value: '$14.990'
  }, {
    number: '02',
    medal: '🥈',
    title: 'BONO 2 — Manual de Seguridad y Calidad',
    tagline: 'El checklist que separa a los aficionados de los profesionales.',
    description: 'Te llevás:',
    bullets: ['Cómo evitar que los sahumerios se apaguen solos', 'Control de secado para que ninguno se quiebre', 'Cómo proteger los aromas de la contaminación cruzada', 'Protocolo de producción para garantizar calidad constante', 'Los 10 errores más comunes que arruinan una producción entera'],
    footer: 'Con este manual, cada sahumerio que salga de tu casa va a ser uno que tus clientes vuelvan a pedir.',
    value: '$12.990'
  }];
  return <section className="w-full bg-[#FBEDE5] donut-pattern py-4 md:py-8 relative" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D2817] text-center mb-3 md:mb-6" data-id="element-18">
            🎁 2 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5 mb-3 md:mb-5 max-w-5xl mx-auto" data-id="element-19">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white border border-[#E8D5BA] rounded-lg p-4 md:p-5 relative overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-20">
                <div className="flex items-start gap-2 mb-2" data-id="element-21">
                  <GiftIcon className="w-5 h-5 text-[#B45309] flex-shrink-0" data-id="element-22" />
                  <span className="text-sm font-bold text-[#B45309]" data-id="element-23">
                    #{bonus.number}
                  </span>
                  <span className="text-xl ml-auto" data-id="element-24">{bonus.medal}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-[#3D2817] mb-1" data-id="element-25">
                  {bonus.title}
                </h3>
                <p className="text-[#B45309] font-semibold mb-2 text-sm italic" data-id="element-26">
                  {bonus.tagline}
                </p>
                <p className="text-[#6B5747] text-sm mb-2" data-id="element-27">
                  {bonus.description}
                </p>
                <ul className="space-y-1.5 mb-3" data-id="element-28">
                  {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2" data-id="element-29">
                      <CheckCircleIcon className="w-4 h-4 text-[#5C8A6D] flex-shrink-0 mt-0.5" data-id="element-30" />
                      <span className="text-[#6B5747] text-sm leading-snug" data-id="element-31">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
                <p className="text-[#3D2817] text-sm font-semibold italic mb-3" data-id="element-32">
                  {bonus.footer}
                </p>
                <div className="flex items-center gap-2 pt-2 border-t border-[#F0E3CE]" data-id="element-33">
                  <span className="text-[#9B8770] line-through text-sm" data-id="element-34">
                    {bonus.value}
                  </span>
                  <span className="text-[#5C8A6D] font-bold text-sm" data-id="element-35">
                    → GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-36">
            <p className="text-lg md:text-xl font-bold text-[#3D2817]" data-id="element-37">
              Valor total de los bonos:{' '}
              <span className="line-through text-[#9B8770]" data-id="element-38">$27.980</span>
              {' → '}
              <span className="text-[#B45309]" data-id="element-39">GRATIS con tu Mega Pack</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}